import 'twin.macro'

import { useTranslation } from '@/utils/useTranslation'
import { graphql } from 'gatsby'
import PageSuggestionForm from '@/components/forms/page-suggestions'
import RichText from '@/components/ui/rich-text'
import PrintWrapper from '@/components/print-wrapper'
import { slugify } from '@/utils/strings'
import { isPrint } from '@/utils/print'
import { useLocation } from '@reach/router'
import HelpParent from './help-parent'

export const query = graphql`
  query ContentfulHelpArticle($id: String!, $locale: String!) {
    contentfulHelpArticle(id: { eq: $id }) {
      title
      slug
      body {
        raw
        references {
          ...Asset
          ...Callout
          ...Code
          ...ComponentImage
          ...HubSpotForm
          ...Icon
          ...Link
          ...Tabs
          ...Video
        }
      }
      updatedAt
      seo {
        ...SEO
      }
    }

    allContentfulHelpNav(filter: { node_locale: { eq: $locale } }, sort: { order: ASC }) {
      nodes {
        title
        items {
          ...HelpArticleLink
          ... on ContentfulHelpCategory {
            contentful_id
            title
            items {
              ...HelpArticleLink
              ... on ContentfulHelpSubcategory {
                contentful_id
                title
                items {
                  ...HelpArticleLink
                }
              }
            }
          }
        }
      }
    }
  }

  fragment HelpArticleLink on ContentfulHelpArticle {
    __typename
    contentful_id
    title
    slug
  }
`

export default function HelpArticle({
  pageContext: { helpNavInitial, otherLocales },
  data: {
    contentfulHelpArticle: { seo, title, body },
    allContentfulHelpNav: { nodes: helpNavNodes },
  },
}) {
  const { t } = useTranslation()
  const { origin, pathname } = useLocation()
  if (isPrint()) {
    return (
      <PrintWrapper
        title={title}
        section={t('Help Center')}
        pageUrl={origin + pathname}
        pageType="help"
        pageBreadcrumb={helpNavInitial}
      >
        <h1 id={slugify(title)}>{title}</h1>
        <RichText body={body} />
      </PrintWrapper>
    )
  }
  return (
    <HelpParent
      {...{
        seo,
        otherLocales,
        title,
        outlineBody: [{ __typename: 'ContentfulComponentRichText', body }],
        helpNavNodes,
        helpNavInitial,
      }}
    >
      <h1 id={slugify(title)} tw="mt-4">
        {title}
      </h1>
      <RichText body={body} />
      <div tw="mt-24">
        <PageSuggestionForm />
      </div>
    </HelpParent>
  )
}
